export default function getFormattedDate (dateString) {
  if (!dateString) return '';
  
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  const date = new Date(dateString);
  
  // Проверяем валидность даты
  if (isNaN(date.getTime())) {
    return '';
  }
  
  const formattedDate = date.toLocaleDateString('ru-RU', options);
  return formattedDate;
}
